import numeral from "numeral";

export default [
    {
        label: 'Part Number',
        field: 'part',
        type: 'text',
    },
    {
        label: 'Description',
        field: 'description',
        type: 'text',
    },
    {
        label: 'Customer',
        field: 'customer',
        type: 'text',
    },
    {
        label: 'Reference',
        field: 'customer_ref',
        type: 'text',
    },
    {
        label: 'Notes',
        field: 'notes',
        type: 'text',
    },
    {
        label: 'Vendor',
        field: 'vendor',
        type: 'text',
    },
    {
        label: 'Unit Cost',
        field: 'unit_cost',
        type: 'number',
        formatFn: function (value) { return numeral(value).format('$0,0,0,0,0.00') }
    },
    {
        label: 'Quote',
        field: 'quote',
        type: 'number',
        formatFn: function (value) { return numeral(value).format('$0,0,0,0,0.00') }
    },
    {
        label: 'Quantity',
        field: 'quantity',
        type: 'number',
    },
    {
        label: 'Ext quote',
        field: 'ext_quote',
        type: 'number',
        formatFn: function (value) { return numeral(value).format('$0,0,0,0,0.00') }
    },
    {
        label: 'Margin',
        field: 'margin',
        type: 'number',
        formatFn: function (value) { return numeral(value).format('0,0,0,0,0.00') + '%' }
    },
    {
        label: 'Type',
        field: 'quote_type',
        type: 'text',
    },
    {
        label: 'UOM',
        field: 'unit_of_measure',
        type: 'text',
    },
    {
        label: 'Date Sold',
        field: 'date_sold',
        type: 'text',
        formatFn: (date) => {
            if (date) {
                if (date.includes('T')) {
                    return date.split('T')[0];
                }
            }
            return date;
        }
    },
    {
        label: 'Sale Qty',
        field: 'sale_qty',
        type: 'text',
    },
    {
        label: 'Sale Price',
        field: 'sale_price',
        type: 'text',
        formatFn: (value) => {
            if (value) {
                return numeral(value).format('$0,0,0,0,0.00');
            }
            return value;
        }
    }
];
